<template>
  <section ref="fiveContainer" class="five-page-section media_section_height">
    <div class="media_screen_style" style="display: flex; flex-direction: column; align-items: center">
      <div style="color: #fff6f6; font-size: 32px; margin-bottom: 16px" class="shake2">
        {{ t("five.title") }}
      </div>
      <!-- 会议管理功能帮助您高效管理会议、保持秩序并确保良好的讨论氛围。 -->
      <div style="color: #fef8f8; font-size: 16px; margin: 0 12px 32px 12px;max-width: 450px;">
        {{ t("five.details") }}
      </div>
      <div class="five_img_bg">
        <!-- 我的信息 -->
        <div :class="indexAnimation == 1 ? 'flash' : null" style="
            position: absolute;
            left: 9px;
            top: 68px;
            width: 30px;
            height: 30px;
            border-radius: 10px;
          "></div>
        <!-- 二维码 -->
        <div :class="indexAnimation == 2 ? 'flash' : null" style="
            position: absolute;
            right: 9px;
            top: 68px;
            width: 30px;
            height: 30px;
            border-radius: 10px;
          "></div>
        <!-- 字幕 -->
        <div :class="indexAnimation == 3 ? 'flash' : null" style="
            position: absolute;
            right: 9px;
            top: 121px;
            width: 30px;
            height: 30px;
            border-radius: 10px;
          "></div>
        <!-- item麦克风/踢出-->
        <div :class="indexAnimation == 4 ? 'flash' : null" style="
            position: absolute;
            right: 16px;
            top: 254px;
            width: 51px;
            height: 30px;
            border-radius: 10px;
          "></div>
        <!-- 全体麦克风-->
        <div :class="indexAnimation == 5 ? 'flash' : null" style="
            position: absolute;
            left: 8px;
            bottom: 10px;
            width: 61px;
            height: 43px;
            border-radius: 14px;
          "></div>

        <img :style="isFading ? 'opacity: 0.8' : null" class="five_img_bg_img" :src="imgBg[lang]" width="300px"
          alt="" />
        <Transition name="slide-fade-left">
          <img v-show="steps[0]" class="five_img_bg_message" :src="imgPop[lang]" width="200px" alt="" />
        </Transition>
        <Transition name="slide-fade">
          <div v-show="steps[1]" class="five_img_bg_qr">{{ t("five.one") }}</div>
        </Transition>
        <Transition name="slide-fade">
          <div v-show="steps[2]" class="five_img_bg_txt">{{ t("five.two") }}</div>
        </Transition>
        <Transition name="slide-fade">
          <div v-show="steps[3]" class="five_img_bg_mic_item">
            {{ t("five.three") }}
          </div>
        </Transition>
        <Transition name="slide-fade-feft">
          <div v-show="steps[4]" class="five_img_bg_mic_all">{{ t("five.four") }}</div>
        </Transition>

        <!-- e:\aaa_bable\bable-flutter\assets\images\new_ui\icon_tonghua_user.svg -->
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";

const isFading = ref(false);
const hasAnimated = ref(false);
const fiveContainer = ref(null);
const indexAnimation = ref(0);
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

const lang = ref("zh");
if (locale.value != 'zh-CN' && locale.value != 'zh') {
  lang.value = "en";
}
const imgBg = {
  zh: new URL('@/assets/4.webp', import.meta.url).href,
  en: new URL('@/assets/4_en.webp', import.meta.url).href,
};
const imgPop = {
  zh: new URL('@/assets/message.webp', import.meta.url).href,
  en: new URL('@/assets/message_en.webp', import.meta.url).href,
};

const steps = ref([false, false, false, false, false, false]);
onMounted(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && !hasAnimated.value) {
        isFading.value = true;
        hasAnimated.value = true;
        steps.value.forEach((_, i) => {
          setTimeout(() => {
            indexAnimation.value = i + 1;
            steps.value[i] = true;
          }, i * 2000); // 每段动画间隔 1 秒
        });
        observer.disconnect();
      }
    },
    {
      threshold: 0.9,
    }
  );

  if (fiveContainer.value) {
    observer.observe(fiveContainer.value);
  }
});
</script>

<style scoped>
.five-page-section {
  /* transform: scale(.7);
  transform-origin: top; */
  /* height: 100vh; */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 32px;
  /* overflow: hidden; */
  /* min-height: 932px; */
}

.five_img_bg {
  position: relative;
  /* display: inline; */
  width: 300px;
  height: 666px;
}

.five_img_bg_img {
  transition: opacity 0.5s ease;
}

.five_img_bg_message {
  position: absolute;
  bottom: 270px;
  right: 120px;
}

.five_img_bg_qr {
  position: absolute;
  top: 43px;
  right: -18px;
  font-size: 12px;
}

.five_img_bg_txt {
  position: absolute;
  top: 160px;
  right: -18px;
  background-color: #f3edf7;
  color: #49454f;
  font-size: 14px;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px #6750a4 solid;
}

.five_img_bg_mic_item {
  position: absolute;
  top: 290px;
  right: -18px;
  background-color: #f3edf7;
  color: #49454f;
  font-size: 14px;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px #6750a4 solid;
}

.five_img_bg_mic_all {
  position: absolute;
  bottom: 60px;
  left: -18px;
  background-color: #f3edf7;
  color: #49454f;
  font-size: 14px;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px #6750a4 solid;
}

.flash {
  animation: flashWhite 6s forwards;
  z-index: 10;
  box-shadow: 0 0 10px white;
}

@keyframes flashWhite {

  0% {
    opacity: 1;
    box-shadow: 0 0 10px white;
  }

  25%,
  75% {
    opacity: 0.3;
    box-shadow: none;
  }

  100% {
    opacity: 0;
  }
}

.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-leave-active {
  transition: all 0.4s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(20%);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateX(0);
}

/* ----- */
.slide-fade-left-enter-active {
  transition: all 1s ease;
}

.slide-fade-left-leave-active {
  transition: all 0.4s ease;
}

.slide-fade-left-enter-from {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-fade-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}
</style>
